"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pincludes = void 0;
var type_system_1 = require("../../../../type_system/index.js");
var papp_1 = require("../../../papp.js");
var pfn_1 = require("../../../pfn.js");
var phoist_1 = require("../../../phoist.js");
var stdEq_1 = require("../../stdEq/index.js");
function pincludes(elems_t) {
    return (0, phoist_1.phoist)((0, phoist_1.phoist)((0, pfn_1.pfn)([
        (0, type_system_1.fn)([elems_t, elems_t], type_system_1.bool),
        (0, type_system_1.list)(elems_t),
        elems_t
    ], type_system_1.bool)(function (eqFn, lst, elem) { return lst.some((0, papp_1.papp)(eqFn, elem)); }, "mk_pincludes")).$((0, stdEq_1.pstdEq)(elems_t)));
}
exports.pincludes = pincludes;
